import React from "react";

import './style.scss'

const PrivacyPage = () => {
    return (
        <div className="privacy-page"> 
            <header>
                <h1>Privacy Policy</h1>
            </header>
            <main>
                <p><strong>Effective Date:</strong> 1 October 2025</p>
                <p>Euro Consult HRMS (“the App”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our mobile application.</p>

                <h2>1. Information We Collect</h2>
                <ul>
                    <li><strong>Device Information:</strong> A unique device ID generated for security and attendance tracking.</li>
                    <li><strong>Location Data:</strong> GPS coordinates collected during check-in and check-out to verify work location compliance.</li>
                    <li><strong>Media:</strong> Photos captured during check-in.</li>
                    <li><strong>Usage Data:</strong> Logs of attendance actions and app interactions.</li>
                </ul>

                <h2>2. How We Use Your Information</h2>
                <ul>
                    <li>Authenticate and manage employee login sessions.</li>
                    <li>Process check-in and check-out attendance with GPS verification.</li>
                    <li>Improve app functionality and ensure security.</li>
                </ul>

                <h2>3. Data Sharing</h2>
                <p>We do not sell or rent your data. Information is only shared with your employer/organization’s HR system as required for attendance, payroll, and compliance purposes.</p>

                <h2>4. Data Storage & Security</h2>
                <p>All data is transmitted securely using encryption. Access tokens and session details are securely stored on your device. We implement safeguards to prevent unauthorized access.</p>

                <h2>5. Your Choices</h2>
                <ul>
                    <li>You may request deletion of your account through your employer’s HR department.</li>
                </ul>

                <h2>6. Permissions Used</h2>
                <ul>
                    <li><strong>Location:</strong> To verify check-in/out location.</li>
                    <li><strong>Camera:</strong> To capture photos for attendance verification.</li>
                    <li><strong>Storage:</strong> To temporarily store attendance photos.</li>
                </ul>

                <h2>7. Changes to This Policy</h2>
                <p>We may update this Privacy Policy from time to time. Updates will be communicated through the app.</p>

                <h2>8. Contact Us</h2>
                <p>If you have questions or concerns, please contact us at:
                    <a href="mailto:support@euroconsult.com">support@euroconsult.com</a></p>
            </main>
        </div>
    );
}

export default PrivacyPage;